export default(key, lang) => {
  let mapping = {
    stepText: {
      en_US: 'The Authenticator App you set up for password recovery will be used for Multi-Factor Authentication.',
      de_DE: 'Die Authenticator-App, die Sie für die Kennwortwiederherstellung eingerichtet haben, wird für die Multi-Faktor-Authentifizierung verwendet.',
      el_GR: 'Η εφαρμογή Authenticator που ρυθμίζετε για ανάκτηση κωδικού πρόσβασης θα χρησιμοποιηθεί για έλεγχο ταυτότητας πολλαπλών παραγόντων.',
      es_ES: 'La aplicación de autenticación que configuró para la recuperación de contraseña se usará para la autenticación multifactor.',
      fr_FR: "L'application Authenticator que vous avez configurée pour la récupération du mot de passe sera utilisée pour l'authentification multifacteur.",
      fr_CA: "L'application Authenticator que vous avez configurée pour la récupération du mot de passe sera utilisée pour l'authentification multifacteur.",
      it_IT: "L'app di autenticazione impostata per il recupero della password verrà utilizzata per l'autenticazione a più fattori.",
      pl_PL: 'Aplikacja Authenticator skonfigurowana do odzyskiwania hasła będzie używana do uwierzytelniania wieloskładnikowego.',
      th_TH: 'แอพ Authenticator ที่คุณตั้งค่าสำหรับการกู้คืนรหัสผ่านจะใช้สำหรับการรับรองความถูกต้องแบบหลายปัจจัย',
      zh_CN: '您為密碼恢復設置的Authenticator應用將用於多重身份驗證。',
      pt_BR: 'O aplicativo Authenticator que você configurou para recuperação de senha será usado para autenticação multifator.',
      ja_JP: 'パスワード回復用に設定した認証アプリは、多要素認証に使用されます。',
    },
    codeDescription: {
      en_US: 'Please enter your six digit verification code.',
      de_DE: 'Bitte geben Sie Ihren sechsstelligen Bestätigungscode ein.',
      el_GR: 'Εισαγάγετε τον εξαψήφιο κωδικό επαλήθευσης.',
      es_ES: 'Ingrese su código de verificación de seis dígitos.',
      fr_FR: 'Veuillez saisir votre code de vérification à six chiffres.',
      fr_CA: 'Veuillez saisir votre code de vérification à six chiffres.',
      it_IT: 'Inserisci il tuo codice di verifica a sei cifre.',
      pl_PL: 'Wprowadź sześciocyfrowy kod weryfikacyjny.',
      th_TH: 'โปรดป้อนรหัสยืนยันหกหลักของคุณ',
      zh_CN: '請輸入您的六位數驗證碼。',
      pt_BR: 'Digite seu código de verificação de seis dígitos.',
      ja_JP: '6桁の確認コードを入力してください。',
    },
    verificationError: {
      en_US: 'Verification code must be 6 numbers',
      de_DE: 'Der Bestätigungscode muss aus 6 Zahlen bestehen',
      el_GR: 'Ο κωδικός επαλήθευσης πρέπει να είναι 6 αριθμοί',
      es_ES: 'El código de verificación debe tener 6 números.',
      fr_FR: 'Le code de vérification doit être composé de 6 chiffres',
      fr_CA: 'Le code de vérification doit être composé de 6 chiffres',
      it_IT: 'Il codice di verifica deve essere di 6 numeri',
      pl_PL: 'Kod weryfikacyjny musi składać się z 6 cyfr',
      th_TH: 'รหัสยืนยันต้องเป็นตัวเลข 6 ตัว',
      zh_CN: '验证码必须为6位数字',
      pt_BR: 'O código de verificação deve ter 6 números',
      ja_JP: '確認コードは6桁の数字でなければなりません',
    },
    isRequiredMessage: {
      en_US: 'This field is required',
      de_DE: 'Dieses Feld wird benötigt.',
      el_GR: 'Αυτό το πεδίο απαιτείται.',
      es_ES: 'Este campo es requerido.',
      fr_FR: 'Ce champ est requis.',
      fr_CA: 'Ce champ est requis.',
      it_IT: 'Questo campo è obbligatorio.',
      pl_PL: 'To pole jest wymagane.',
      th_TH: 'ต้องระบุข้อมูลในฟิลด์นี้',
      zh_CN: '这是必填栏。',
      pt_BR: 'Este campo é obrigatório.',
      ja_JP: 'この項目は必須です。',
    },
  };
  return mapping[key][lang];
};